import React, { forwardRef } from "react";

import { ITypographyProps, Typography } from "../Typography";

export const Header2 = forwardRef<
  HTMLDivElement,
  Omit<ITypographyProps, "weight" | "variant">
>(({ children, ...props }, ref) => {
  return (
    <Typography weight="bold" variant="Header 2" ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Header2.displayName = "Header2";
